(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebonform-artist-submission"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-efas]');
  if (!root || root.dataset.efasReady === 'true') return;
  root.dataset.efasReady = 'true';
  const targets = [...root.querySelectorAll('[data-efas-reveal]')];
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    targets.forEach((item) => item.classList.add('is-seen'));
    return;
  }
  root.classList.add('efas-motion');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-seen');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
  targets.forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-collection-uniform"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.efcInitialized) return;
    root.dataset.efcInitialized = 'true';

    const grid = root.querySelector('[data-efc-grid]');
    const cards = Array.from(root.querySelectorAll('[data-efc-card]'));
    const resultLabel = root.querySelector('[data-efc-result-label]');
    const empty = root.querySelector('[data-efc-empty]');
    const mobileRows = window.matchMedia('(max-width: 749px)');

    root.querySelectorAll('[data-efc-gallery]').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('.efc-card__image'));
      if (!slides.length) return;
      let selected = 0;
      const show = (index) => {
        const current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.style.opacity = i === current ? '1' : '0';
          slide.style.visibility = i === current ? 'visible' : 'hidden';
        });
      };
      show(0);
      const media = gallery.querySelector('.efc-card__media');
      media?.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && slides.length > 1) show(1);
      });
      media?.addEventListener('pointerleave', () => show(selected));
      media?.addEventListener('focus', () => {
        if (slides.length > 1) show(1);
      });
      media?.addEventListener('blur', () => show(selected));
    });

    const render = () => {
      if (!grid) return;
      grid.replaceChildren();

      if (!mobileRows.matches) {
        cards.forEach((card) => {
          card.hidden = false;
          grid.appendChild(card);
        });
      } else {
        for (let start = 0; start < cards.length; start += 5) {
          const row = document.createElement('section');
          row.className = 'efc-mobile-row';
          row.setAttribute('aria-label', 'Collector works');

          const controls = document.createElement('div');
          controls.className = 'efc-mobile-row__controls';

          const previous = document.createElement('button');
          previous.className = 'efc-mobile-row__arrow';
          previous.type = 'button';
          previous.setAttribute('aria-label', root.dataset.prevLabel || 'Previous works');
          previous.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M10 7l-5 5 5 5"/></svg>';

          const next = document.createElement('button');
          next.className = 'efc-mobile-row__arrow';
          next.type = 'button';
          next.setAttribute('aria-label', root.dataset.nextLabel || 'Next works');
          next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M14 7l5 5-5 5"/></svg>';

          controls.append(previous, next);

          const rail = document.createElement('div');
          rail.className = 'efc-mobile-row__rail';

          cards.slice(start, start + 5).forEach((card) => {
            card.hidden = false;
            rail.appendChild(card);
          });

          const cardStep = () => {
            const first = rail.querySelector('.efc-card');
            if (!first) return rail.clientWidth;
            const gap = parseFloat(getComputedStyle(rail).gap) || 0;
            return first.getBoundingClientRect().width + gap;
          };

          const updateArrows = () => {
            const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
            previous.disabled = rail.scrollLeft <= 2;
            next.disabled = rail.scrollLeft >= max - 2;
          };

          const move = (direction) => {
            rail.scrollBy({
              left: direction * cardStep(),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          };

          previous.addEventListener('click', () => move(-1));
          next.addEventListener('click', () => move(1));
          rail.addEventListener('scroll', () => requestAnimationFrame(updateArrows), { passive:true });

          row.append(controls, rail);
          grid.appendChild(row);
          requestAnimationFrame(updateArrows);
        }
      }

      if (resultLabel) {
        const count = cards.length;
        const one = root.dataset.resultOne || '1 work';
        const many = root.dataset.resultMany || '999 works';
        resultLabel.textContent = count === 1 ? one : many.replace('999', String(count));
      }
      if (empty) empty.hidden = cards.length !== 0;
      grid.hidden = cards.length === 0;
    };

    const onModeChange = () => render();
    if (typeof mobileRows.addEventListener === 'function') {
      mobileRows.addEventListener('change', onModeChange);
    } else if (typeof mobileRows.addListener === 'function') {
      mobileRows.addListener(onModeChange);
    }

    render();
  };

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-efc]').forEach(init);
  });

  document.querySelectorAll('[data-efc]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-collector-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-efcontact]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const targets = [...root.querySelectorAll('[data-efcontact-reveal]')];
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('is-seen'));
    return;
  }

  root.classList.add('efcontact-motion');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-seen');
      observer.unobserve(entry.target);
    });
  }, { threshold:.12, rootMargin:'0px 0px -6% 0px' });

  targets.forEach(el => observer.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-home-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initVideoHero = (section) => {
    if (section.dataset.efh2VideoReady === 'true') return;
    section.dataset.efh2VideoReady = 'true';
    const video = section.querySelector('[data-efh2-video]');
    const playToggle = section.querySelector('[data-efh2-video-toggle]');
    const muteToggle = section.querySelector('[data-efh2-video-mute]');
    if (!video || !playToggle || !muteToggle) return;

    const syncPlay = () => {
      const paused = video.paused;
      playToggle.classList.toggle('is-paused', paused);
      playToggle.setAttribute('aria-label', paused ? playToggle.dataset.playLabel : playToggle.dataset.pauseLabel);
    };
    const syncMute = () => {
      muteToggle.classList.toggle('is-unmuted', !video.muted);
      muteToggle.setAttribute('aria-label', video.muted ? muteToggle.dataset.unmuteLabel : muteToggle.dataset.muteLabel);
    };

    video.muted = true;
    video.playsInline = true;
    const attemptPlay = () => {
      const result = video.play();
      if (result?.catch) result.catch(() => syncPlay());
    };

    playToggle.addEventListener('click', () => {
      if (video.paused) attemptPlay();
      else video.pause();
    });
    muteToggle.addEventListener('click', () => {
      video.muted = !video.muted;
      syncMute();
      if (video.paused) attemptPlay();
    });
    video.addEventListener('play', syncPlay);
    video.addEventListener('pause', syncPlay);
    video.addEventListener('volumechange', syncMute);
    video.addEventListener('canplay', attemptPlay, { once: true });
    syncPlay();
    syncMute();
    attemptPlay();
  };

  const initMobileWorksRows = (home) => {
    if (!home || home.dataset.efh2MobileRowsReady === 'true') return;
    home.dataset.efh2MobileRowsReady = 'true';

    const rail = home.querySelector('.efh2-works__rail');
    if (!rail) return;

    const mobileQuery = window.matchMedia('(max-width: 699px)');
    let originalCards = [];
    let rowsBuilt = false;

    const collectCards = () => {
      if (originalCards.length) return originalCards;
      originalCards = Array.from(rail.querySelectorAll('.efh2-work-card'));
      originalCards.forEach((card, index) => {
        card.dataset.efh2OriginalIndex = String(index);
      });
      return originalCards;
    };

    const syncButtons = (viewport, prev, next) => {
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      prev.disabled = viewport.scrollLeft <= 4;
      next.disabled = viewport.scrollLeft >= max - 4;
    };

    const restore = () => {
      if (!rowsBuilt) return;
      const cards = collectCards()
        .slice()
        .sort((a, b) => Number(a.dataset.efh2OriginalIndex) - Number(b.dataset.efh2OriginalIndex));

      rail.querySelectorAll('.efh2-mobile-work-row').forEach((row) => row.remove());
      cards.forEach((card) => {
        card.removeAttribute('data-efh2-mobile-hidden');
        rail.appendChild(card);
      });
      rowsBuilt = false;
    };

    const build = () => {
      const cards = collectCards();
      if (!mobileQuery.matches) {
        restore();
        return;
      }
      if (rowsBuilt) return;

      cards.forEach((card) => card.remove());
      cards.forEach((card, index) => {
        if (index >= 20) {
          card.dataset.efh2MobileHidden = 'true';
          rail.appendChild(card);
        }
      });

      const visible = cards.slice(0, 20);
      for (let start = 0; start < visible.length; start += 4) {
        const group = visible.slice(start, start + 4);
        if (!group.length) continue;

        const row = document.createElement('div');
        row.className = 'efh2-mobile-work-row';

        const viewport = document.createElement('div');
        viewport.className = 'efh2-mobile-work-row__viewport';

        const track = document.createElement('div');
        track.className = 'efh2-mobile-work-row__track';

        group.forEach((card) => track.appendChild(card));
        viewport.appendChild(track);
        row.appendChild(viewport);

        const controls = document.createElement('div');
        controls.className = 'efh2-mobile-work-row__controls';

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.setAttribute('aria-label', 'Previous products');
        prev.textContent = '←';

        const next = document.createElement('button');
        next.type = 'button';
        next.setAttribute('aria-label', 'Next products');
        next.textContent = '→';

        controls.append(prev, next);
        row.appendChild(controls);
        rail.appendChild(row);

        const step = () => Math.max(0, viewport.clientWidth);

        prev.addEventListener('click', () => {
          viewport.scrollBy({ left: -step(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          viewport.scrollBy({ left: step(), behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', () => syncButtons(viewport, prev, next), { passive: true });
        window.addEventListener('resize', () => syncButtons(viewport, prev, next), { passive: true });
        requestAnimationFrame(() => syncButtons(viewport, prev, next));
      }

      rowsBuilt = true;
    };

    collectCards();
    build();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', build);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(build);
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.efh2-video-hero').forEach(initVideoHero);
    scope.querySelectorAll('[data-efh2]').forEach(initMobileWorksRows);
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-efj2]');
  if (!root || root.dataset.efj2Ready === 'true') return;
  root.dataset.efj2Ready = 'true';
  const targets = [...root.querySelectorAll('[data-efj2-reveal]')];
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    targets.forEach((item) => item.classList.add('is-seen'));
    return;
  }
  root.classList.add('efj2-motion-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-seen');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
  targets.forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-lion-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ef-hero-motion')) {
  const init = () => document.querySelectorAll('.ef-gallery-hero__wall').forEach(wall => {
    if (wall.dataset.ready) return;
    wall.dataset.ready = 'true';
    const object = wall.querySelector('.ef-gallery-hero__object');
    const motion = window.matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover) and (min-width: 750px)');
    if (!object) return;
    wall.addEventListener('pointermove', event => {
      if (!motion.matches) return;
      const r = wall.getBoundingClientRect();
      object.style.setProperty('--ef-ry', ((event.clientX-r.left)/r.width-.5)*4+'deg');
      object.style.setProperty('--ef-rx', (.5-(event.clientY-r.top)/r.height)*3+'deg');
    });
    wall.addEventListener('pointerleave', () => { object.style.removeProperty('--ef-rx'); object.style.removeProperty('--ef-ry'); });
  });
  init();
  document.addEventListener('shopify:section:load', init);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebonform-payment-methods"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-efpm]');
  if (!root || root.dataset.efpmReady === 'true') return;
  root.dataset.efpmReady = 'true';
  const targets = [...root.querySelectorAll('[data-efpm-reveal]')];
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    targets.forEach((item) => item.classList.add('is-seen'));
    return;
  }
  root.classList.add('efpm-motion');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-seen');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
  targets.forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
